<template>
  <div class="userLog-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-button type="primary" size="small" @click="getResource('status')">查询</el-button>
      <el-button type="primary" size="small" @click="resourceAction('add',null)">新增资源</el-button>
    </div>
    <!--表格数据-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" ref="multipleTable">
      <el-table-column prop="ID" label="ID" align="center" min-width="220">
        <template slot-scope="scope">
          <span>{{scope.row.id || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型" align="center" min-width="220">
        <template slot-scope="scope">
          <span>{{scope.row.type === "bg" ? "背景图" : "头像"}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="resource"
        label="资源"
        align="center"
        width="140"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <img-load
            :width="'80px'"
            :height="'80px'"
            :src="imgUrl + scope.row.resource"
          ></img-load>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" align="center" min-width="240">
        <template slot-scope="scope">
          <span>{{scope.row.updatedAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" min-width="80">
        <template slot-scope="scope">
          <!-- <el-button type="success" icon="el-icon-edit" size="mini" @click="awardAction('edit',scope.row)"></el-button> -->
          <el-button type="primary" icon="el-icon-delete" size="mini" @click="removeResource(scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[ 10, 15, 20, 25]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <!--新增、编辑弹框-->
    <resource-action ref="resourceAction" @handlerClose="handlerClose"></resource-action>
  </div>
</template>
<script>
import API from '@/api'
import ResourceAction from "./components/resourceAction"
import baseConfig from "@/utils/serverUrlConfig";
export default {
  data() {
    return {
      tableData: [],
      loading: false,
      total: 0,
      imgUrl: baseConfig.imgUrl,
      typeList: [
        { value: '发送评论限制', code: 'comment' },
        { value: '用户注册限制', code: 'login' },
        { value: '全局限制', code: 'global' },
      ],
      // 请求限制ip列表参数
      params: {
        pageNumber: 1,
        pageSize: 10,
        type: ''
      }
    }
  },
  filters: {
    typeRule(value) {
      switch (value) {
        case 'comment':
          return '发送评论限制';
        case 'login':
          return '用户注册限制';
        case 'global':
          return '全局限制';
        default:
          return '未知';
      }
    }
  },
  components: {
    ResourceAction
  },
  created() {
    this.getResource()
  },
  methods: {
    // 请求订单列表
    getResource(type) {
      this.loading = true
      if (type === 'status') {
        this.params.pageNumber = 1
      }
      API.getResource(this.params).then(res => {
        if (res.code === 200 && res.data.list) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size
      this.getResource()
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number
      this.getResource()
    },
    // 新增、编辑操作
    resourceAction(type, data) {
      this.$refs.resourceAction.open(type, data)
    },
    // 监听编辑、或者添加成功过后重新拉去数据
    handlerClose() {
      this.getResource()
    },
    // 删除限制
    removeResource(item) {
      const params = {id: item.id}
      this.$confirm('您确定要删除吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        API.delResource(params).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getResource()
          } else {
            this.$message({
              message: '删除失败！',
              type: 'success'
            });
          }
        })
      }).catch(er => {
        // eslint-disable-next-line no-console
        console.log(er)
      })
    }
  }
}
</script>
